"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NoDataPlaceholder_1 = __importDefault(require("./NoDataPlaceholder"));

exports.default = NoDataPlaceholder_1.default;